import { ClockIcon } from "../../../../../assets";
import { getFormattedDate } from "../../../../../utils";
import { InformationBox } from "../../../../../widget";

export interface ProjectAccessRequestBoxProps {
  isLoading: boolean;
  /** When the current organisation's outstanding access request was sent, if it has one. */
  pendingRequestSentDate?: Date;
  onViewPendingRequest: () => void;
  onRequestAccess: () => void;
  /** The asset manager portal rounds its cards; the developer and development manager portals do not. */
  corners?: "rounded" | "default";
}

/** The "Limited view" notice shown on a project the user cannot read, with the access request journey. */
export const ProjectAccessRequestBox = ({
  isLoading,
  pendingRequestSentDate,
  onViewPendingRequest,
  onRequestAccess,
  corners = "rounded",
}: ProjectAccessRequestBoxProps): JSX.Element => {
  if (isLoading) {
    return (
      <InformationBox
        variant="loading"
        corners={corners}
        direction="row"
        hasBorder
        title="Checking access request status"
      />
    );
  }

  if (pendingRequestSentDate) {
    return (
      <InformationBox
        variant="info"
        title="Limited view"
        corners={corners}
        direction="row"
        onEdit={onViewPendingRequest}
        editText="Access requested"
        editIcon={<ClockIcon />}
        editDirection="reverse"
        hasBorder
        hasUnderline={false}
      >
        <p className="body1">Your organisation has requested access on {getFormattedDate(pendingRequestSentDate)}</p>
      </InformationBox>
    );
  }

  return (
    <InformationBox
      variant="info"
      title="Limited view"
      editText="Request access"
      onEdit={onRequestAccess}
      corners={corners}
      direction="row"
      hasBorder
      hasUnderline={false}
    >
      <p className="body1">You do not have access to view all project data</p>
    </InformationBox>
  );
};
